export default __webpack_public_path__ + "static/media/trash.43abd16f.svg";